import React from 'react';
import { cn } from '../../lib/utils';
import { getStatusColor } from '../../constants/masterData';

/**
 * StatusBadge — badge de estado reutilizable.
 *
 * Props:
 *   status    — texto del estado (usa getStatusColor de masterData)
 *   className — clases adicionales
 *   dot       — mostrar punto de color antes del texto (por defecto true)
 */
const StatusBadge = ({ status, className, dot = true }) => {
  if (!status) return null;

  const colorClass = getStatusColor(status);

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap',
        colorClass,
        className
      )}
    >
      {dot && (
        <span className="w-1.5 h-1.5 rounded-full bg-current opacity-80 flex-shrink-0" />
      )}
      {status}
    </span>
  );
};

export default StatusBadge;
